<template>
	<layout-splash title="Reset Password">
		<div class="h-full w-96">
			<h1 class="bg-green text-3xl px-6 py-4 text-white font-bold">
				{{ __("Reset Password") }}
			</h1>

			<form class="flex flex-col">
				<div class="pt-4 pb-6 px-6 space-y-4">
					<!-- todo daniel styling the alerts -->
					<div
						v-if="success"
						class="rounded-lg text-green-500 bg-green-100 font-medium -mx-2 px-2 py-2"
					>
						{{ success }}
					</div>
					<div
						v-else-if="error"
						class="rounded-lg text-red-600 bg-red-100 font-medium -mx-2 px-2 py-2"
					>
						{{ error }}
					</div>

					<ui-input-group
						class="col-span-6"
						v-model="form.email"
						field="email"
						label="E-Mail"
						:form="form"
						:required="true"
					></ui-input-group>

					<ui-input-group
						class="col-span-6"
						v-model="form.password"
						autocomplete="new-password"
						field="password"
						label="Password"
						type="password"
						:form="form"
						:required="true"
					></ui-input-group>

					<ui-input-group
						class="col-span-6"
						v-model="form.password_confirmation"
						autocomplete="new-password"
						field="password_confirmation"
						label="Password confirmation"
						type="password"
						:form="form"
						:required="true"
					></ui-input-group>
				</div>
				<div class="flex justify-end pt-4 pb-6 px-6 bg-gray-50 sm:rounded-b-xl">
					<ui-button v-on:click="submit()" type="primary">{{
						__("Reset Password")
					}}</ui-button>
				</div>
			</form>
		</div>
	</layout-splash>
</template>

<script>
export default {
	props: {
		defaults: {
			type: Object,
			required: true,
		},
		success: {
			type: String,
		},
		error: {
			type: String,
		},
	},
	data() {
		return {
			form: this.$inertia.form(
				Object.assign(
					{ password: null, password_confirmation: null },
					this.defaults
				)
			),
		};
	},
	methods: {
		submit() {
			this.form.post(this.$route("password.update"));
		},
	},
};
</script>
